import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Dependants = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M24.654 15.033C25.639 13.485 26.25 11.562 26.25 10C26.25 6.692 23.558 4 20.25 4C18.653 4 17.201 4.628 16.125 5.649C15.049 4.628 13.597 4 12 4C8.692 4 6 6.692 6 10C6 11.526 6.584 13.396 7.53 14.925C5.423 16.133 4 18.402 4 21V25C4 26.654 5.346 28 7 28H25C26.654 28 28 26.654 28 25V21C28 18.478 26.659 16.265 24.654 15.032V15.033ZM20.25 6C22.456 6 24.25 7.794 24.25 10C24.25 12.479 22.181 16 20.25 16C19.155 16 18.016 14.867 17.235 13.434C17.72 12.276 18 11.055 18 10C18 9.015 17.76 8.086 17.337 7.265C18.067 6.488 19.102 6 20.25 6V6ZM12 6C14.206 6 16 7.794 16 10C16 12.479 13.931 16 12 16C10.069 16 8 12.479 8 10C8 7.794 9.794 6 12 6ZM6 25V21C6 19.039 7.136 17.339 8.784 16.521C9.763 17.483 10.868 18 12 18C12 20.206 13.794 22 16 22H18C19.103 22 20 22.897 20 24C20 25.103 19.103 26 18 26H7C6.449 26 6 25.551 6 25ZM26 25C26 25.551 25.551 26 25 26H21.462C21.803 25.411 22 24.728 22 24C22 21.794 20.206 20 18 20H16C14.897 20 14 19.103 14 18V17.45C14.766 17.02 15.487 16.345 16.125 15.447C17.299 17.097 18.751 18 20.25 18C21.349 18 22.422 17.515 23.38 16.606C24.939 17.453 26 19.104 26 21V25Z" />
	</svg>
);

export default Dependants;
